// a library to wrap and simplify api calls
import axios from 'axios'

let serverUrlInput = false
if (typeof document !== 'undefined') {
  const serverUrlEl = document.getElementById('apiRootUrl')
  if (serverUrlEl) {
    serverUrlInput = serverUrlEl.value
  }
}

let crmUrlInput = false
if (typeof document !== 'undefined') {
  const crmUrlEl = document.getElementById('apiRootUrlCRM')
  if (crmUrlEl) {
    crmUrlInput = crmUrlEl.value
  }
}

export const serverUrl = serverUrlInput ? serverUrlInput : API_LINK
export const serverUrlCrm = crmUrlInput ? crmUrlInput : CRM_API_LINK

// our "constructor"
const tokenElement = document.getElementById('callbackToken')
let token = ''
if (tokenElement && tokenElement.value) {
  token = tokenElement.value
}

const operatingHoursApi = axios.create({
  baseURL: `${serverUrlCrm}/`,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  },
  transformRequest: [(data, headers) => {
    delete headers.common.Authorization
    delete headers.Authorization
    return JSON.stringify(data)
  }]
})

const suri20ApiHeaders = {
  'Content-Type': 'application/json',
}

if (token) {
  suri20ApiHeaders.Authorization = `Bearer ${token}`
}

const suri20Api = axios.create({
  baseURL: `${serverUrl}/`,
  timeout: 100000,
  headers: suri20ApiHeaders,
})

const setHeader = (name, value) => {
  if (value) {
    axios.defaults.headers.common[name] = value
  } else {
    delete axios.defaults.headers.common[name]
  }
}

const endpoints = {

  // post
  operatingHours: data => operatingHoursApi.post('OperatingHours', data),
  sendCallbackRequest: (data) => suri20Api.post('visit/callback', data),
  // put

  // get
  getSettings: () => suri20Api.get('content/settings'),
  getWorkingHours: () => suri20Api.get('content/callback-working-hours'),


  // delete

  // helpers
  serverUrl,
  setHeader
}

export default endpoints
